import { gql } from '@grandvisionhq/graphql';

const insurance = gql`
  fragment InsuranceFragment on OrderInsurance {
    sku
    id
    quantity
    name {
      value
    }
    price {
      total {
        gross
        net
        subtotal
      }
      unit {
        gross
        net
        subtotal
      }
    }
    policyNumber
  }
`;

export { insurance };
//# sourceMappingURL=insurance.js.map
